import { View } from "react-native";
import { COMMENTS, REACTIONS } from "src/api/featureFlags";
import PhotoState from "src/api/graphql/__generated__/enums/PhotoState";
import PhotoVariant from "src/api/graphql/__generated__/enums/PhotoVariant";
import OpacityView from "src/components/OpacityView";
import { paddingLarge, paddingMedium } from "src/styles/spacing";
import { AnimatePresence } from "src/swsh-native";
import usePhotoDetailStore from "../../../../stores/usePhotoDetailStore";
import { PhotoItem } from "../../../../types";
import PhotoDetailCommentButton from "../../../PhotoDetailCommentButton";
import PhotoDetailReactionsButton from "../../../PhotoDetailReactionsButton/PhotoDetailReactionsButton";
import PhotoDetailTagDisplay from "./components/PhotoDetailTagDisplay";

const MainPhotoOverlay = ({
	photo,
	width,
	height,
}: {
	photo: PhotoItem;
	width: number;
	height: number;
}) => {
	const isCorrectMode = usePhotoDetailStore((state) => state.mode === "Regular");
	const isWaitingForCurPhotoLoad = usePhotoDetailStore((state) => state.isWaitingForCurPhotoLoad);
	const isFocused = usePhotoDetailStore(
		(state) => state.debouncedCurPhoto?.photoId === photo.photoId,
	);

	return (
		<AnimatePresence>
			{isFocused &&
				isCorrectMode &&
				!isWaitingForCurPhotoLoad &&
				photo.variant !== PhotoVariant.Video && (
					<OpacityView
						key="DynamicOverlay"
						style={{
							position: "absolute",
							width,
							height,
						}}
						pointerEvents="box-none"
					>
						<PhotoDetailTagDisplay
							photo={photo}
							photoScreenWidth={width}
							photoScreenHeight={height}
						/>

						{photo.state === PhotoState.Active && (
							<View
								style={{
									position: "absolute",
									bottom: paddingLarge,
									right: paddingLarge,
									columnGap: paddingMedium,
									flexDirection: "row",
									alignItems: "center",
								}}
							>
								{REACTIONS && <PhotoDetailReactionsButton photo={photo} />}
								{COMMENTS && <PhotoDetailCommentButton photo={photo} />}
							</View>
						)}
					</OpacityView>
				)}
		</AnimatePresence>
	);
};
export default MainPhotoOverlay;
